/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AssistantHandoffsListParams,
  AssistantQuotesListParams,
  AssistantSettings,
  AssistantSettingsListParams,
  AssistantSettingsRequest,
  FlightQuote,
  FlightQuoteRequest,
  Handoff,
  PaginatedAssistantSettingsList,
  PaginatedFlightQuoteList,
  PaginatedHandoffList,
  PatchedAssistantSettingsRequest,
  PatchedFlightQuoteRequest,
  SandboxRequestRequest,
  SandboxResponse
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Conversations the AI handed over: an advisor takes them (P1-08). They quote the
client's messages: the accountant and the trainer do not read them (P4-06, D-115).
 */
export type assistantHandoffsListResponse200 = {
  data: PaginatedHandoffList
  status: 200
}
    
export type assistantHandoffsListResponseSuccess = (assistantHandoffsListResponse200) & {
  headers: Headers;
};
;

export type assistantHandoffsListResponse = (assistantHandoffsListResponseSuccess)

export const getAssistantHandoffsListUrl = (params?: AssistantHandoffsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assistant/handoffs/?${stringifiedParams}` : `/api/v1/assistant/handoffs/`
}

export const assistantHandoffsList = async (params?: AssistantHandoffsListParams, options?: RequestInit): Promise<assistantHandoffsListResponse> => {
  
  return apiFetch<assistantHandoffsListResponse>(getAssistantHandoffsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAssistantHandoffsListQueryKey = (params?: AssistantHandoffsListParams,) => {
    return [
    `/api/v1/assistant/handoffs/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAssistantHandoffsListQueryOptions = <TData = Awaited<ReturnType<typeof assistantHandoffsList>>, TError = unknown>(params?: AssistantHandoffsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssistantHandoffsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof assistantHandoffsList>>> = ({ signal }) => assistantHandoffsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssistantHandoffsListQueryResult = NonNullable<Awaited<ReturnType<typeof assistantHandoffsList>>>
export type AssistantHandoffsListQueryError = unknown


export function useAssistantHandoffsList<TData = Awaited<ReturnType<typeof assistantHandoffsList>>, TError = unknown>(
 params: undefined |  AssistantHandoffsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantHandoffsList>>,
          TError,
          Awaited<ReturnType<typeof assistantHandoffsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantHandoffsList<TData = Awaited<ReturnType<typeof assistantHandoffsList>>, TError = unknown>(
 params?: AssistantHandoffsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantHandoffsList>>,
          TError,
          Awaited<ReturnType<typeof assistantHandoffsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantHandoffsList<TData = Awaited<ReturnType<typeof assistantHandoffsList>>, TError = unknown>(
 params?: AssistantHandoffsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAssistantHandoffsList<TData = Awaited<ReturnType<typeof assistantHandoffsList>>, TError = unknown>(
 params?: AssistantHandoffsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssistantHandoffsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Conversations the AI handed over: an advisor takes them (P1-08). They quote the
client's messages: the accountant and the trainer do not read them (P4-06, D-115).
 */
export type assistantHandoffsRetrieveResponse200 = {
  data: Handoff
  status: 200
}
    
export type assistantHandoffsRetrieveResponseSuccess = (assistantHandoffsRetrieveResponse200) & {
  headers: Headers;
};
;

export type assistantHandoffsRetrieveResponse = (assistantHandoffsRetrieveResponseSuccess)

export const getAssistantHandoffsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/assistant/handoffs/${id}/`
}

export const assistantHandoffsRetrieve = async (id: string, options?: RequestInit): Promise<assistantHandoffsRetrieveResponse> => {
  
  return apiFetch<assistantHandoffsRetrieveResponse>(getAssistantHandoffsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAssistantHandoffsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/assistant/handoffs/${id}/`
    ] as const;
    }

    
export const getAssistantHandoffsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssistantHandoffsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>> = ({ signal }) => assistantHandoffsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssistantHandoffsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>>
export type AssistantHandoffsRetrieveQueryError = unknown


export function useAssistantHandoffsRetrieve<TData = Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantHandoffsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof assistantHandoffsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantHandoffsRetrieve<TData = Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantHandoffsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof assistantHandoffsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantHandoffsRetrieve<TData = Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAssistantHandoffsRetrieve<TData = Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantHandoffsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssistantHandoffsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Conversations the AI handed over: an advisor takes them (P1-08). They quote the
client's messages: the accountant and the trainer do not read them (P4-06, D-115).
 */
export type assistantHandoffsResolveCreateResponse200 = {
  data: Handoff
  status: 200
}
    
export type assistantHandoffsResolveCreateResponseSuccess = (assistantHandoffsResolveCreateResponse200) & {
  headers: Headers;
};
;

export type assistantHandoffsResolveCreateResponse = (assistantHandoffsResolveCreateResponseSuccess)

export const getAssistantHandoffsResolveCreateUrl = (id: string,) => {


  

  return `/api/v1/assistant/handoffs/${id}/resolve/`
}

export const assistantHandoffsResolveCreate = async (id: string, options?: RequestInit): Promise<assistantHandoffsResolveCreateResponse> => {
  
  return apiFetch<assistantHandoffsResolveCreateResponse>(getAssistantHandoffsResolveCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getAssistantHandoffsResolveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantHandoffsResolveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantHandoffsResolveCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['assistantHandoffsResolveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantHandoffsResolveCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  assistantHandoffsResolveCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssistantHandoffsResolveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof assistantHandoffsResolveCreate>>>
    
    export type AssistantHandoffsResolveCreateMutationError = unknown

    export const useAssistantHandoffsResolveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantHandoffsResolveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantHandoffsResolveCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAssistantHandoffsResolveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type assistantQuotesListResponse200 = {
  data: PaginatedFlightQuoteList
  status: 200
}
    
export type assistantQuotesListResponseSuccess = (assistantQuotesListResponse200) & {
  headers: Headers;
};
;

export type assistantQuotesListResponse = (assistantQuotesListResponseSuccess)

export const getAssistantQuotesListUrl = (params?: AssistantQuotesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assistant/quotes/?${stringifiedParams}` : `/api/v1/assistant/quotes/`
}

export const assistantQuotesList = async (params?: AssistantQuotesListParams, options?: RequestInit): Promise<assistantQuotesListResponse> => {
  
  return apiFetch<assistantQuotesListResponse>(getAssistantQuotesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAssistantQuotesListQueryKey = (params?: AssistantQuotesListParams,) => {
    return [
    `/api/v1/assistant/quotes/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAssistantQuotesListQueryOptions = <TData = Awaited<ReturnType<typeof assistantQuotesList>>, TError = unknown>(params?: AssistantQuotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssistantQuotesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof assistantQuotesList>>> = ({ signal }) => assistantQuotesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssistantQuotesListQueryResult = NonNullable<Awaited<ReturnType<typeof assistantQuotesList>>>
export type AssistantQuotesListQueryError = unknown


export function useAssistantQuotesList<TData = Awaited<ReturnType<typeof assistantQuotesList>>, TError = unknown>(
 params: undefined |  AssistantQuotesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantQuotesList>>,
          TError,
          Awaited<ReturnType<typeof assistantQuotesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantQuotesList<TData = Awaited<ReturnType<typeof assistantQuotesList>>, TError = unknown>(
 params?: AssistantQuotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantQuotesList>>,
          TError,
          Awaited<ReturnType<typeof assistantQuotesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantQuotesList<TData = Awaited<ReturnType<typeof assistantQuotesList>>, TError = unknown>(
 params?: AssistantQuotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAssistantQuotesList<TData = Awaited<ReturnType<typeof assistantQuotesList>>, TError = unknown>(
 params?: AssistantQuotesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssistantQuotesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type assistantQuotesRetrieveResponse200 = {
  data: FlightQuote
  status: 200
}
    
export type assistantQuotesRetrieveResponseSuccess = (assistantQuotesRetrieveResponse200) & {
  headers: Headers;
};
;

export type assistantQuotesRetrieveResponse = (assistantQuotesRetrieveResponseSuccess)

export const getAssistantQuotesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/assistant/quotes/${id}/`
}

export const assistantQuotesRetrieve = async (id: string, options?: RequestInit): Promise<assistantQuotesRetrieveResponse> => {
  
  return apiFetch<assistantQuotesRetrieveResponse>(getAssistantQuotesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAssistantQuotesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/assistant/quotes/${id}/`
    ] as const;
    }

    
export const getAssistantQuotesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssistantQuotesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof assistantQuotesRetrieve>>> = ({ signal }) => assistantQuotesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssistantQuotesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof assistantQuotesRetrieve>>>
export type AssistantQuotesRetrieveQueryError = unknown


export function useAssistantQuotesRetrieve<TData = Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantQuotesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof assistantQuotesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantQuotesRetrieve<TData = Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantQuotesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof assistantQuotesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantQuotesRetrieve<TData = Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAssistantQuotesRetrieve<TData = Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantQuotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssistantQuotesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type assistantQuotesUpdateResponse200 = {
  data: FlightQuote
  status: 200
}
    
export type assistantQuotesUpdateResponseSuccess = (assistantQuotesUpdateResponse200) & {
  headers: Headers;
};
;

export type assistantQuotesUpdateResponse = (assistantQuotesUpdateResponseSuccess)

export const getAssistantQuotesUpdateUrl = (id: string,) => {


  

  return `/api/v1/assistant/quotes/${id}/`
}

export const assistantQuotesUpdate = async (id: string,
    flightQuoteRequest: FlightQuoteRequest, options?: RequestInit): Promise<assistantQuotesUpdateResponse> => {
  
  return apiFetch<assistantQuotesUpdateResponse>(getAssistantQuotesUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      flightQuoteRequest,)
  }
);}




export const getAssistantQuotesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantQuotesUpdate>>, TError,{id: string;data: FlightQuoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantQuotesUpdate>>, TError,{id: string;data: FlightQuoteRequest}, TContext> => {

const mutationKey = ['assistantQuotesUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantQuotesUpdate>>, {id: string;data: FlightQuoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  assistantQuotesUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssistantQuotesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof assistantQuotesUpdate>>>
    export type AssistantQuotesUpdateMutationBody = FlightQuoteRequest
    export type AssistantQuotesUpdateMutationError = unknown

    export const useAssistantQuotesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantQuotesUpdate>>, TError,{id: string;data: FlightQuoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantQuotesUpdate>>,
        TError,
        {id: string;data: FlightQuoteRequest},
        TContext
      > => {

      const mutationOptions = getAssistantQuotesUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type assistantQuotesPartialUpdateResponse200 = {
  data: FlightQuote
  status: 200
}
    
export type assistantQuotesPartialUpdateResponseSuccess = (assistantQuotesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type assistantQuotesPartialUpdateResponse = (assistantQuotesPartialUpdateResponseSuccess)

export const getAssistantQuotesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/assistant/quotes/${id}/`
}

export const assistantQuotesPartialUpdate = async (id: string,
    patchedFlightQuoteRequest: PatchedFlightQuoteRequest, options?: RequestInit): Promise<assistantQuotesPartialUpdateResponse> => {
  
  return apiFetch<assistantQuotesPartialUpdateResponse>(getAssistantQuotesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedFlightQuoteRequest,)
  }
);}




export const getAssistantQuotesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantQuotesPartialUpdate>>, TError,{id: string;data: PatchedFlightQuoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantQuotesPartialUpdate>>, TError,{id: string;data: PatchedFlightQuoteRequest}, TContext> => {

const mutationKey = ['assistantQuotesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantQuotesPartialUpdate>>, {id: string;data: PatchedFlightQuoteRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  assistantQuotesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssistantQuotesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof assistantQuotesPartialUpdate>>>
    export type AssistantQuotesPartialUpdateMutationBody = PatchedFlightQuoteRequest
    export type AssistantQuotesPartialUpdateMutationError = unknown

    export const useAssistantQuotesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantQuotesPartialUpdate>>, TError,{id: string;data: PatchedFlightQuoteRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantQuotesPartialUpdate>>,
        TError,
        {id: string;data: PatchedFlightQuoteRequest},
        TContext
      > => {

      const mutationOptions = getAssistantQuotesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * P1-02: the published bible is used here exactly as on WhatsApp; nothing is sent.
 */
export type assistantSandboxCreateResponse200 = {
  data: SandboxResponse
  status: 200
}
    
export type assistantSandboxCreateResponseSuccess = (assistantSandboxCreateResponse200) & {
  headers: Headers;
};
;

export type assistantSandboxCreateResponse = (assistantSandboxCreateResponseSuccess)

export const getAssistantSandboxCreateUrl = () => {


  

  return `/api/v1/assistant/sandbox/`
}

export const assistantSandboxCreate = async (sandboxRequestRequest: SandboxRequestRequest, options?: RequestInit): Promise<assistantSandboxCreateResponse> => {
  
  return apiFetch<assistantSandboxCreateResponse>(getAssistantSandboxCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sandboxRequestRequest,)
  }
);}




export const getAssistantSandboxCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantSandboxCreate>>, TError,{data: SandboxRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantSandboxCreate>>, TError,{data: SandboxRequestRequest}, TContext> => {

const mutationKey = ['assistantSandboxCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantSandboxCreate>>, {data: SandboxRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  assistantSandboxCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssistantSandboxCreateMutationResult = NonNullable<Awaited<ReturnType<typeof assistantSandboxCreate>>>
    export type AssistantSandboxCreateMutationBody = SandboxRequestRequest
    export type AssistantSandboxCreateMutationError = unknown

    export const useAssistantSandboxCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantSandboxCreate>>, TError,{data: SandboxRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantSandboxCreate>>,
        TError,
        {data: SandboxRequestRequest},
        TContext
      > => {

      const mutationOptions = getAssistantSandboxCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Safety lists of the AI: read by the team, changed by the owner only (bible §5).
 */
export type assistantSettingsListResponse200 = {
  data: PaginatedAssistantSettingsList
  status: 200
}
    
export type assistantSettingsListResponseSuccess = (assistantSettingsListResponse200) & {
  headers: Headers;
};
;

export type assistantSettingsListResponse = (assistantSettingsListResponseSuccess)

export const getAssistantSettingsListUrl = (params?: AssistantSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/assistant/settings/?${stringifiedParams}` : `/api/v1/assistant/settings/`
}

export const assistantSettingsList = async (params?: AssistantSettingsListParams, options?: RequestInit): Promise<assistantSettingsListResponse> => {
  
  return apiFetch<assistantSettingsListResponse>(getAssistantSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAssistantSettingsListQueryKey = (params?: AssistantSettingsListParams,) => {
    return [
    `/api/v1/assistant/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAssistantSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof assistantSettingsList>>, TError = unknown>(params?: AssistantSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssistantSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof assistantSettingsList>>> = ({ signal }) => assistantSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssistantSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof assistantSettingsList>>>
export type AssistantSettingsListQueryError = unknown


export function useAssistantSettingsList<TData = Awaited<ReturnType<typeof assistantSettingsList>>, TError = unknown>(
 params: undefined |  AssistantSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantSettingsList>>,
          TError,
          Awaited<ReturnType<typeof assistantSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantSettingsList<TData = Awaited<ReturnType<typeof assistantSettingsList>>, TError = unknown>(
 params?: AssistantSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantSettingsList>>,
          TError,
          Awaited<ReturnType<typeof assistantSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantSettingsList<TData = Awaited<ReturnType<typeof assistantSettingsList>>, TError = unknown>(
 params?: AssistantSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAssistantSettingsList<TData = Awaited<ReturnType<typeof assistantSettingsList>>, TError = unknown>(
 params?: AssistantSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssistantSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Safety lists of the AI: read by the team, changed by the owner only (bible §5).
 */
export type assistantSettingsRetrieveResponse200 = {
  data: AssistantSettings
  status: 200
}
    
export type assistantSettingsRetrieveResponseSuccess = (assistantSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type assistantSettingsRetrieveResponse = (assistantSettingsRetrieveResponseSuccess)

export const getAssistantSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/assistant/settings/${id}/`
}

export const assistantSettingsRetrieve = async (id: string, options?: RequestInit): Promise<assistantSettingsRetrieveResponse> => {
  
  return apiFetch<assistantSettingsRetrieveResponse>(getAssistantSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAssistantSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/assistant/settings/${id}/`
    ] as const;
    }

    
export const getAssistantSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAssistantSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof assistantSettingsRetrieve>>> = ({ signal }) => assistantSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AssistantSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof assistantSettingsRetrieve>>>
export type AssistantSettingsRetrieveQueryError = unknown


export function useAssistantSettingsRetrieve<TData = Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof assistantSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantSettingsRetrieve<TData = Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof assistantSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof assistantSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAssistantSettingsRetrieve<TData = Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAssistantSettingsRetrieve<TData = Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof assistantSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAssistantSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Safety lists of the AI: read by the team, changed by the owner only (bible §5).
 */
export type assistantSettingsUpdateResponse200 = {
  data: AssistantSettings
  status: 200
}
    
export type assistantSettingsUpdateResponseSuccess = (assistantSettingsUpdateResponse200) & {
  headers: Headers;
};
;

export type assistantSettingsUpdateResponse = (assistantSettingsUpdateResponseSuccess)

export const getAssistantSettingsUpdateUrl = (id: string,) => {


  

  return `/api/v1/assistant/settings/${id}/`
}

export const assistantSettingsUpdate = async (id: string,
    assistantSettingsRequest: AssistantSettingsRequest, options?: RequestInit): Promise<assistantSettingsUpdateResponse> => {
  
  return apiFetch<assistantSettingsUpdateResponse>(getAssistantSettingsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      assistantSettingsRequest,)
  }
);}




export const getAssistantSettingsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantSettingsUpdate>>, TError,{id: string;data: AssistantSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantSettingsUpdate>>, TError,{id: string;data: AssistantSettingsRequest}, TContext> => {

const mutationKey = ['assistantSettingsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantSettingsUpdate>>, {id: string;data: AssistantSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  assistantSettingsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssistantSettingsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof assistantSettingsUpdate>>>
    export type AssistantSettingsUpdateMutationBody = AssistantSettingsRequest
    export type AssistantSettingsUpdateMutationError = unknown

    export const useAssistantSettingsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantSettingsUpdate>>, TError,{id: string;data: AssistantSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantSettingsUpdate>>,
        TError,
        {id: string;data: AssistantSettingsRequest},
        TContext
      > => {

      const mutationOptions = getAssistantSettingsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Safety lists of the AI: read by the team, changed by the owner only (bible §5).
 */
export type assistantSettingsPartialUpdateResponse200 = {
  data: AssistantSettings
  status: 200
}
    
export type assistantSettingsPartialUpdateResponseSuccess = (assistantSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type assistantSettingsPartialUpdateResponse = (assistantSettingsPartialUpdateResponseSuccess)

export const getAssistantSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/assistant/settings/${id}/`
}

export const assistantSettingsPartialUpdate = async (id: string,
    patchedAssistantSettingsRequest: PatchedAssistantSettingsRequest, options?: RequestInit): Promise<assistantSettingsPartialUpdateResponse> => {
  
  return apiFetch<assistantSettingsPartialUpdateResponse>(getAssistantSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedAssistantSettingsRequest,)
  }
);}




export const getAssistantSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantSettingsPartialUpdate>>, TError,{id: string;data: PatchedAssistantSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assistantSettingsPartialUpdate>>, TError,{id: string;data: PatchedAssistantSettingsRequest}, TContext> => {

const mutationKey = ['assistantSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assistantSettingsPartialUpdate>>, {id: string;data: PatchedAssistantSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  assistantSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssistantSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof assistantSettingsPartialUpdate>>>
    export type AssistantSettingsPartialUpdateMutationBody = PatchedAssistantSettingsRequest
    export type AssistantSettingsPartialUpdateMutationError = unknown

    export const useAssistantSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assistantSettingsPartialUpdate>>, TError,{id: string;data: PatchedAssistantSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assistantSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedAssistantSettingsRequest},
        TContext
      > => {

      const mutationOptions = getAssistantSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    